module.exports = __webpack_public_path__ + "img/CHAT.06df3fe3.png";